import React from 'react';
import { Input, Button } from 'antd';
const { TextArea } = Input;

/**
 * A single TextArea editor for different language prompts.
 * Props:
 *  - prompt: { id: string | number }
 *  - currentLanguage: string (e.g. 'CN', 'EN', 'JA', etc.)
 *  - translate: (promptId, language) => void  // translate action
 *  - currentXPrompt, setCurrentXPrompt: state and setter for each language
 */
const PromptEditTextArea = ({
                                prompt,
                                currentLanguage,
                                translate,

                                currentChinesePrompt, setCurrentChinesePrompt,
                                currentEnglishPrompt, setCurrentEnglishPrompt,
                                currentJapanesePrompt, setCurrentJapanesePrompt,
                                currentCantonesePrompt, setCurrentCantonesePrompt,
                                currentChineseTaiwanPrompt, setCurrentChineseTaiwanPrompt,
                                currentFrenchPrompt, setCurrentFrenchPrompt,
                                currentHindiPrompt, setCurrentHindiPrompt,
                                currentSpanishPrompt, setCurrentSpanishPrompt,
                                currentPortuguesePrompt, setCurrentPortuguesePrompt,
                                currentArabicPrompt, setCurrentArabicPrompt,
                                currentRussianPrompt, setCurrentRussianPrompt,
                                currentKoreanPrompt, setCurrentKoreanPrompt,
                            }) => {
    // Map language codes to label, value, setter, and whether translation is available
    const langMap = {
        CN: {
            label: 'Chinese Prompt',
            value: currentChinesePrompt,
            setter: setCurrentChinesePrompt,
            translatable: true,
        },
        EN: {
            label: 'English Prompt',
            value: currentEnglishPrompt,
            setter: setCurrentEnglishPrompt,
            translatable: false,
        },
        JA: {
            label: 'Japanese Prompt',
            value: currentJapanesePrompt,
            setter: setCurrentJapanesePrompt,
            translatable: true,
        },
        ZH_HK: {
            label: 'Cantonese Prompt',
            value: currentCantonesePrompt,
            setter: setCurrentCantonesePrompt,
            translatable: true,
        },
        ZH_TW: {
            label: 'Traditional Chinese (Taiwan) Prompt',
            value: currentChineseTaiwanPrompt,
            setter: setCurrentChineseTaiwanPrompt,
            translatable: true,
        },
        FR: {
            label: 'French Prompt',
            value: currentFrenchPrompt,
            setter: setCurrentFrenchPrompt,
            translatable: true,
        },
        HI: {
            label: 'Hindi Prompt',
            value: currentHindiPrompt,
            setter: setCurrentHindiPrompt,
            translatable: true,
        },
        ES: {
            label: 'Spanish Prompt',
            value: currentSpanishPrompt,
            setter: setCurrentSpanishPrompt,
            translatable: true,
        },
        PT: {
            label: 'Portuguese Prompt',
            value: currentPortuguesePrompt,
            setter: setCurrentPortuguesePrompt,
            translatable: true,
        },
        AR: {
            label: 'Arabic Prompt',
            value: currentArabicPrompt,
            setter: setCurrentArabicPrompt,
            translatable: true,
        },
        RU: {
            label: 'Russian Prompt',
            value: currentRussianPrompt,
            setter: setCurrentRussianPrompt,
            translatable: true,
        },
        KO: {
            label: 'Korean Prompt',
            value: currentKoreanPrompt,
            setter: setCurrentKoreanPrompt,
            translatable: true,
        },
    };

    const config = langMap[currentLanguage];
    if (!config) return null;

    const { label, value, setter, translatable } = config;

    return (
        <div>
            <h4>
                {label}
                {translatable && (
                    <Button
                        type="primary"
                        style={{ marginLeft: 12 }}
                        onClick={() => translate(prompt.id, currentLanguage)}
                    >
                        Translate
                    </Button>
                )}
            </h4>

            <TextArea
                autoSize={true}
                value={value}
                onChange={e => setter(e.target.value)}
            />
        </div>
    );
};

export default PromptEditTextArea;
